<template>
    <div dusk="SmartZoomModalFooter" class="flex h-full items-center bg-theme-bg px-4">
        <div class="flex w-full items-center justify-between">
            <transition name="fade">
                <button
                    v-if="!isFirstArticle"
                    dusk="SmartZoomPrevButton"
                    class="inline-flex items-center rounded px-3 py-2 transition-all hover:bg-theme-icon-bg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    @click="onPrev"
                >
                    <svg-icon
                        icon="ic_keyboard_arrow_left_white_24px"
                        width="24px"
                        height="24px"
                        class="text-theme-icon"
                    ></svg-icon>
                    <span class="ml-1 text-sm font-medium text-theme-text">{{ localizations[lang].prevArticle }}</span>
                </button>
            </transition>
            <div v-if="isFirstArticle"></div>
            <transition name="fade">
                <button
                    v-if="!isLastArticle"
                    dusk="SmartZoomNextButton"
                    class="inline-flex items-center rounded px-3 py-2 transition-all hover:bg-theme-icon-bg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    @click="onNext"
                >
                    <span class="mr-1 text-sm font-medium text-theme-text">{{ localizations[lang].nextArticle }}</span>
                    <svg-icon
                        icon="ic_keyboard_arrow_right_white_24px"
                        width="24px"
                        height="24px"
                        class="text-theme-icon"
                    ></svg-icon>
                </button>
            </transition>
        </div>
    </div>
</template>

<script>
'use strict';

import { mapState } from 'vuex';

export default {
    props: {
        isFirstArticle: {
            type: Boolean,
            required: true,
        },
        isLastArticle: {
            type: Boolean,
            required: true,
        },
        currentArticleNumber: {
            type: Number,
            required: true,
        },
        totalArticles: {
            type: Number,
            required: true,
        },
        onPrev: {
            type: Function,
            required: true,
        },
        onNext: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
};
</script>
